import { useState, useEffect } from "react";                    
import Swal from 'sweetalert2'; 
import swal from 'sweetalert2';                    
import RateBar from "./rateBar";   
import { getOrderReport } from "../api/fnbAPI";
import EditFnbCancellation from "./editFnbCancellation";

const OrderReport = (props) => {

    const [selectedFromDate,                setSelectedFromDate]         = useState(moment().toDate());
    const [selectedToDate,                  setSelectedToDate]           = useState(moment().toDate());
    const [isInit,                          setIsInit]                   = useState(true);
    const [orderSheet,                      setOrderSheet]               = useState([]);
    const [cancellationDetails,             setCancellationDetails]      = useState(null);
    const [orderTable,                      setOrderTable]               = useState(null);
    const [rateDetails,                     setRateDetails]              = useState({
        totalAmount: 0,
        totalTax: 0,
        finalAmount: 0,
        fromDate: '',
        toDate: '',
        total: 0,
        type: "Total Bookings"
    });

    useEffect(() => {
        if (orderSheet.length > 0) {
            const totalAmount = orderSheet.reduce((sum, item) => sum + item.TotalOrderRate, 0);
            const totalTax = orderSheet.reduce((sum, item) => sum + item.TotalTax, 0); // Assuming 9% CGST
            const finalAmount = orderSheet.reduce((sum, item) => sum + item.TotalAmount, 0);

            setRateDetails({
                totalAmount,
                totalTax,
                finalAmount,
                fromDate: moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), // Example: Get first entry date
                toDate: moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                total: orderSheet.length,
                type: "Total Bookings"
            });
        }
    }, [orderSheet]);

    useEffect(() => {
        props.title('Order Report','order-report')
        $('#txtFromDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtFromDate').on('change', function (event) {
            setSelectedFromDate(event.target.value)
        }); 
        $('#txtToDate').datepicker({
            format: 'dd-mm-yyyy',
            minDate: new Date(),
        });  
        $('#txtToDate').on('change', function (event) {
            setSelectedToDate(event.target.value)
        }); 
    },[])
    
    useEffect(() => {       
        if (!isInit) {
            fillTable();
        }
    }, [orderSheet]);

    useEffect(() => {
        if(selectedFromDate && selectedToDate){
            fetchFnbOrderSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))
        }
    },[selectedFromDate, selectedToDate])

    const fetchFnbOrderSheet = async(fdate, tDate) => {
        try {
            swal.fire({
                titleText: 'Loading',
                text: 'Please Wait...',
                showConfirmButton: false,
                onOpen: () => {
                    swal.showLoading();
                }
            });
            const booking = await getOrderReport(fdate, tDate);
            isInit ? setIsInit(false) : $('#tblCancelSheet').KTDatatable().destroy(); 
            // return
            setOrderSheet(booking)
            swal.close();
        } catch (err) {
            Swal.fire({
                icon      : 'error',
                titleText : err.message
            })  
        }
    }

    function exportSheet(type) {
        orderTable.update({
            headers: true,
            formats: ["xlsx", "csv"],
            filename: `${moment().format("DD-MM-YYYY")} - Fnb Order Sheet` // pass in a new set of properties
        });

        if (type == 'xlsx') {
            $('.button-default.xlsx').click();
        } else {
            $('.button-default.csv').click();
        }
        $('.tableexport-caption').addClass('hidden');
    }

    function fillTable() {

        // var startType = $('#ddlStart').val();
        var filteredList = orderSheet;
        var tableFields = []

        Swal.close();

        $.each(filteredList, function (index, element) {

            if (element.Status != null) {
                element["Status"] = '<div class="badge badge-danger"><span>' + element["Status"] + '</span></div>';
            }

        });

        tableFields = [{ field: "Slot", title: "Slot", width: 60 } ]

        Config.Core.InitPopover();

        const dataTable = $('#tblCancelSheet').KTDatatable({
            
            data: {
                saveState: false,
                source: filteredList,
            },
            layout: {
                scroll: false,
                footer: false,
            },
            sortable: false,
            pagination: false,
            search: {
                input: $('#generalSearch'),
            },
            columns: [
                {
                    field: 'CreatedDate',
                    title: "Bill Dt",
                    width: 50,
                    template: function (row) {
                        return moment(row.CreatedDate).format('DD-MM-YYYY');
                    }
                },  
                {  field: 'Slot',  title: 'Slot', 
                },
                {
                    field: 'UserName',
                    title: 'User',
                }, 
                {
                    field: 'MembershipNo',
                    title: 'Mem.No',
                    width: 100,
                },
                {
                    field: 'Type',
                    title: 'Type',
                    width: 45,
                }, 
                {
                    field: 'Location',
                    title: 'Location',
                    width: 90,
                },
                {
                    field: 'PaymentType',
                    title: 'Pay-Type',
                    width: 70,
                },
                {
                    field: 'PaymentMode',
                    title: 'Pay-Mode',
                    width: 80,
                    template: function (row) {
                        if (row.PaymentMode === "Cash Card") {
                            return `Cash Card (${row.CardName})`;
                        } else {
                            return row.PaymentMode;
                        }
                    }
                },
                {
                    field: 'TrackingID',
                    title: 'Tracking ID',
                    width: 120,
                },
                {
                    field: 'BillNo',
                    title: 'Bill No',
                    width: 140,
                },
                {
                    field: 'TotalAmount',
                    title: 'Bill Amt',
                    width: 80,
                },
                {
                    field: 'Status',
                    title: 'Status',
                    width: 80,
                    template: function (row) {
                        if (row.Status === "Pending") {
                            return "<div class='badge badge-warning'><span>Pending</span></div>";
                        } else if (row.Status === "Cancelled"){
                            return "<div class='badge badge-danger'><span>Cancelled</span></div>";
                        } else {
                            return "<div class='badge badge-success'><span>Success</span></div>";
                        }
                    },
                },
                {
                    field: '',
                    title: '',
                    width: 50,
                    class: "clickable",
                    template: function (row) {
                        return showEditButton(row)
                    }
                },
            ],
            rows: {
                autoHide: false,
            }
            
        });
        Config.Core.InitPopover();
        Config.Core.GrabAndScroll('.kt-datatable__table');
        function showEditButton(row) {

            var optString = '';
            optString += '<center>'
            optString += `<button type="button"  class="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-edit"><i class="flaticon2-edit"></i></button>`
            optString += '</center>'
            return optString;
        }
        // export to excel
        const orderTable = $('.kt-datatable__table').tableExport({
            formats: ["xlsx", "csv"],
            headers: true,
            filename: `${moment().format("DD-MM-YYYY")} - Fnb Order Sheet`,
        });
        setOrderTable(orderTable);
        $('.tableexport-caption').addClass('hidden');
        $('.tableexport-caption').addClass('hidden');

        dataTable.on('click', '.btn-edit', function (ss) {
            const index = $(ss.currentTarget).parents('tr').index();
            if (dataTable.dataSet && dataTable.dataSet.length > 0 && dataTable.dataSet[index]) {
                setCancellationDetails(dataTable.dataSet[index]) 
                
            } 
        });
    }

    return (
        <>
            <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor padding-tb0" id="kt_content"  >
                <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid margin-t20">
                    <div className="kt-portlet">
                        <div className="kt-portlet__body padding-t20 padding-b0">
                            <div id="ControlHolder" className="kt-form kt-form--label-right padding-10" role="form">
                                <div className="row">
                                    <label className="col-form-label col-sm-1 text-right">From Date</label>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtFromDate" 
                                                name="txtFromDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedFromDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <label className="col-form-label col-sm-1 text-right">To Date</label>
                                    <div className="form-group  col-sm-2">
                                        <div className="input-group date">
                                            <input 
                                                id="txtToDate" 
                                                name="txtToDate" 
                                                type="text" 
                                                className="form-control" 
                                                placeholder="Select date" 
                                                defaultValue={moment(selectedToDate, 'DD-MM-YYYY').format('DD-MM-YYYY')} 
                                            />
                                            <div className="input-group-append">
                                                <span className="input-group-text">
                                                    <i className="la la-calendar-check-o"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-2">
                                        <div className="input-group">
                                            <div className="kt-input-icon kt-input-icon--left">
                                                <input 
                                                    type="text" 
                                                    className="form-control clientSearch" 
                                                    placeholder="Search..." 
                                                    id="generalSearch" 
                                                />
                                                <span className="kt-input-icon__icon kt-input-icon__icon--left"><span><i className="la la-search"></i></span></span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-1">
                                        <div className="dropdown">
                                            <button className="btn btn-label-brand dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Export
                                            </button>
                                            <div className="dropdown-menu " aria-labelledby="dropdownMenuButton" x-placement="bottom-start" style={{position: 'absolute', willChange: 'transform', top: '0px', left: '0px', transform: 'translate3d(0px, 38px, 0px)'}}>
                                                <button 
                                                    id="btn-export-excel" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('xlsx')}

                                                > Excel 
                                                </button>
                                                <button 
                                                    id="btn-export-csv" 
                                                    type="button" 
                                                    className="dropdown-item"
                                                    onClick={() => exportSheet('csv')}
                                                >  Csv </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <RateBar
                                rateDetails={rateDetails}
                            />
                            <div id="tblCancelSheet" className="table table-bordered table-hover custom-datatable"></div>
                        </div>
                    </div>
                </div>
            </div>
            {!!cancellationDetails && (
                <EditFnbCancellation
                    fnbCancellationDetails={cancellationDetails}
                    from={"orderReport"}
                    onDismissModal={setCancellationDetails}
                    refetchData={() => fetchFnbOrderSheet(moment(selectedFromDate, 'DD-MM-YYYY').format('YYYY-MM-DD'), moment(selectedToDate, 'DD-MM-YYYY').format('YYYY-MM-DD'))}
                />
            )}
        </>
    )
}

export default OrderReport